export const iconFontAwesomeMapsNewspaper = (
	<i className="fa-solid fa-newspaper"></i>
);
